import { useState } from "react";
import { FaRegEye, FaRegEyeSlash } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { setCurrentUser } from "../utils/authService";
import api from "../api/api";
import Marque from "react-fast-marquee";
import BG from "../assets/images/study-group.jpg";
import {
  AFFILIATE_ID,
  AffiliateName,
  ApplicationSessionList,
  CertificateOptions,
  ClassOfDegreeOptions,
  DepartmentList,
  InstitutionName,
  SchoolLogo,
} from "../utils";
import { useForm } from "react-hook-form";

const PortalSignup = () => {
  const defaultValues = {
    first_name: "",
    last_name: "",
    email: "",
    phone: "",
    application_session_id: undefined,
    department_id: undefined,
    password: "",
    affiliate_id: AFFILIATE_ID,
    programme_name: "Diploma",
    certificate_obtained: "",
    school_name: "",
    class_of_degree: "",
    year_obtained: undefined,
  };

  const {
    register,
    handleSubmit,
    watch,
    formState: { errors },
  } = useForm({ defaultValues });

  const [loading, setLoading] = useState(false);
  const [btnText, setBtnText] = useState("Signup");
  const [showPassword, setShowPassword] = useState(false);

  const navigate = useNavigate();

  const errorProp = {
    position: "top-right",
    autoClose: 2000,
    hideProgressBar: true,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: "colored",
  };

  const successProp = {
    position: "top-right",
    autoClose: 2000,
    hideProgressBar: true,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: "colored",
  };

  const studentSignup = async (formData) => {
    try {
      setBtnText("Loading...");
      const { data } = await api.post("/students/signup/", formData);
      console.log("Result", data);
      toast.success("Signup successful", successProp);
      setBtnText("Signup");
      navigate("/login", {state: { matric_number: data.student.matric_number }});
    } catch (error) {
      console.log(error);
      setBtnText("Failed, try again");
      toast.error(JSON.stringify(error.response.data) ?? "Error occurred", errorProp);
    }
  };

  console.log(watch());

  // Get current year and generate an array of 50 years back
  const currentYear = new Date().getFullYear();
  const years = Array.from({ length: 50 }, (_, i) => currentYear - i);

  return (
    <div
      className="min-h-screen w-full font-inter"
      style={{
        backgroundImage: `url(${BG})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <div className="absolute inset-0 bg-black opacity-35"></div>
      {/* Content */}
      <div className="relative flex justify-center items-center h-full">
        <div className="w-full max-w-6xl flex flex-wrap justify-center items-center">
          {/* Left Column */}
          {/* <div className="w-full md:w-1/2 p-5 hidden md:block">
            <div>
              <img
                className="w-[120px] h-[120px] object-cover mb-6"
                src={SchoolLogo}
                alt="Logo"
              />
              <h1 className="text-white text-4xl font-semibold leading-[43.57px]">
                {InstitutionName}
              </h1>
              {AffiliateName && (
                <>
                  <h1 className="text-white text-xl font-medium uppercase leading-[43.57px]">
                    In Affiliation with
                  </h1>
                  <h1 className="text-white text-3xl font-semibold leading-[43.57px]">
                    {AffiliateName}
                  </h1>
                </>
              )}
              <h1 className="text-white text-4xl font-semibold leading-[43.57px] pt-16">
                Building the Future...
              </h1>
              <p className="text-white mt-6">
                Refining the next generation of leaders and industry
                professionals through a robust and inclusive academic
                curriculum.
              </p>
            </div>
          </div> */}

          {/* Right Column */}
          <div className="w-full md:w-1/2 p-4">
            {/* On Small Screens: Show Logo and Text Above Form */}
            <div className="block text-center mb-6">
              <img
                className="w-[60px] h-[60px] mx-auto"
                src={SchoolLogo}
                alt="Logo"
              />
              <h1 className="text-white text-2xl font-bold mt-4">
                {InstitutionName}
              </h1>
              {AffiliateName && (
                <>
                  <h1 className="text-white text-lg font-medium mt-2">
                    In Affiliation with
                  </h1>
                  <h1 className="text-white text-2xl font-bold mt-2">
                    {AffiliateName}
                  </h1>
                </>
              )}
            </div>

            {/* Form */}
            <div className="bg-[hsla(0,17%,95%,0.95)] w-full max-w-md p-6 rounded-xl shadow-xl mx-auto">
              {/* Header */}
              <h1 className="text-black text-2xl leading-[44px] font-medium mb-6 font-poppins">
                create account
              </h1>

              <form
                className="space-y-4"
                onSubmit={handleSubmit(studentSignup)}
              >
                {/* Inputs */}
                <div className="">
                  <label className="text-sm">First name</label>
                  <input
                    type="text"
                    placeholder="Enter your first name"
                    {...register("first_name", { required: true })}
                    className="w-full bg-[rgba(255,255,255,0.2)] border border-[rgba(217,217,217,0.5)]  rounded-lg px-4 py-3 focus:outline-none focus:ring focus:ring-blue-300"
                  />
                  {errors.first_name && (
                    <span className="text-xs text-red-500">Field required</span>
                  )}
                </div>

                <div className="">
                  <label className="text-sm">Last name</label>
                  <input
                    type="text"
                    placeholder="Enter your last name"
                    {...register("last_name", { required: true })}
                    className="w-full bg-[rgba(255,255,255,0.2)] border border-[rgba(217,217,217,0.5)]  rounded-lg px-4 py-3 focus:outline-none focus:ring focus:ring-blue-300"
                  />
                  {errors.last_name && (
                    <span className="text-xs text-red-500">Field required</span>
                  )}
                </div>

                <div className="">
                  <label className="text-sm">Email address</label>
                  <input
                    type="email"
                    placeholder="Enter your email address"
                    {...register("email", { required: true })}
                    className="w-full bg-[rgba(255,255,255,0.2)] border border-[rgba(217,217,217,0.5)]  rounded-lg px-4 py-3 focus:outline-none focus:ring focus:ring-blue-300"
                  />
                  {errors.email && (
                    <span className="text-xs text-red-500">Field required</span>
                  )}
                </div>

                <div className="">
                  <label className="text-sm">Phone number</label>
                  <input
                    type="number"
                    placeholder="Enter your phone number"
                    {...register("phone", { required: true })}
                    className="w-full bg-[rgba(255,255,255,0.2)] border border-[rgba(217,217,217,0.5)]  rounded-lg px-4 py-3 focus:outline-none focus:ring focus:ring-blue-300"
                  />
                  {errors.phone && (
                    <span className="text-xs text-red-500">Field required</span>
                  )}
                </div>

                <div className="">
                  <label className="text-sm">Department</label>
                  <select
                    {...register("department_id", {
                      required: true,
                      valueAsNumber: true,
                    })}
                    className="w-full bg-[rgba(255,255,255,0.2)] border border-[rgba(217,217,217,0.5)]  rounded-lg px-4 py-3 focus:outline-none focus:ring focus:ring-blue-300"
                  >
                    <option value="">Select a department</option>
                    {DepartmentList.map((department) => (
                      <option key={department.id} value={department.id}>
                        {department.name}
                      </option>
                    ))}
                  </select>
                  {errors.department_id && (
                    <span className="text-xs text-red-500">Field required</span>
                  )}
                </div>

                <div className="">
                  <label className="text-sm">Application session</label>
                  <select
                    {...register("application_session_id", {
                      required: true,
                      valueAsNumber: true,
                    })}
                    className="w-full bg-[rgba(255,255,255,0.2)] border border-[rgba(217,217,217,0.5)]  rounded-lg px-4 py-3 focus:outline-none focus:ring focus:ring-blue-300"
                  >
                    <option value="">Select an application session</option>
                    {ApplicationSessionList.map((session) => (
                      <option key={session.id} value={session.id}>
                        {session.name}
                      </option>
                    ))}
                  </select>
                  {errors.application_session_id && (
                    <span className="text-xs text-red-500">Field required</span>
                  )}
                </div>

                <div className="">
                  <label className="text-sm">Certificate obtained</label>
                  <select
                    {...register("certificate_obtained", {
                      required: true,
                    })}
                    className="w-full bg-[rgba(255,255,255,0.2)] border border-[rgba(217,217,217,0.5)]  rounded-lg px-4 py-3 focus:outline-none focus:ring focus:ring-blue-300"
                  >
                    <option value="">Select certificate obtained</option>
                    {CertificateOptions.map((option) => (
                      <option key={option.value} value={option.value}>
                        {option.label}
                      </option>
                    ))}
                  </select>
                  {errors.certificate_obtained && (
                    <span className="text-xs text-red-500">Field required</span>
                  )}
                </div>

                <div className="">
                  <label className="text-sm">School name</label>
                  <input
                    type="text"
                    placeholder="Enter your school name"
                    {...register("school_name", { required: true })}
                    className="w-full bg-[rgba(255,255,255,0.2)] border border-[rgba(217,217,217,0.5)]  rounded-lg px-4 py-3 focus:outline-none focus:ring focus:ring-blue-300"
                  />
                  {errors.school_name && (
                    <span className="text-xs text-red-500">Field required</span>
                  )}
                </div>

                <div className="">
                  <label className="text-sm">Class of degree</label>
                  <select
                    {...register("class_of_degree", {
                      required: true,
                    })}
                    className="w-full bg-[rgba(255,255,255,0.2)] border border-[rgba(217,217,217,0.5)]  rounded-lg px-4 py-3 focus:outline-none focus:ring focus:ring-blue-300"
                  >
                    <option value="">Select class of degree</option>
                    {ClassOfDegreeOptions.map((option) => (
                      <option key={option.value} value={option.value}>
                        {option.label}
                      </option>
                    ))}
                  </select>
                  {errors.class_of_degree && (
                    <span className="text-xs text-red-500">Field required</span>
                  )}
                </div>

                <div className="">
                  <label className="text-sm">Year obtained</label>
                  <select
                    {...register("year_obtained", {
                      required: true,
                      valueAsNumber: true,
                    })}
                    className="w-full bg-[rgba(255,255,255,0.2)] border border-[rgba(217,217,217,0.5)]  rounded-lg px-4 py-3 focus:outline-none focus:ring focus:ring-blue-300"
                  >
                    <option value="">Select year obtained</option>
                    {years.map((year) => (
                      <option key={year} value={year}>
                        {year}
                      </option>
                    ))}
                  </select>
                  {errors.year_obtained && (
                    <span className="text-xs text-red-500">Field required</span>
                  )}
                </div>

                {/* Password Input */}
                <div>
                  <div className="relative">
                    <label className="text-sm">Password</label>
                    <input
                      type={showPassword ? "text" : "password"}
                      placeholder="Enter your password"
                      {...register("password", { required: true })}
                      className="w-full bg-[rgba(255,255,255,0.2)] border border-[rgba(217,217,217,0.5)] rounded-lg px-6 py-3 focus:outline-none focus:ring focus:ring-blue-300"
                    />
                    {showPassword ? (
                      <span className="absolute right-3 top-12 text-gray-400 cursor-pointer">
                        <FaRegEye onClick={() => setShowPassword(false)} />
                      </span>
                    ) : (
                      <span className="absolute right-3 top-12 text-gray-400 cursor-pointer">
                        <FaRegEyeSlash onClick={() => setShowPassword(true)} />
                      </span>
                    )}
                  </div>
                  {errors.password && (
                    <span className="text-xs text-red-500">Field required</span>
                  )}
                </div>

                {/* Login Link */}
                <div className="text-left mb-10">
                  <a
                    href="/login"
                    className="text-[rgba(83,80,80,1)] text-sm font-medium mb-8"
                  >
                    Login instead
                  </a>
                </div>

                {/* Login Button */}
                <button
                  type="submit"
                  className="w-full bg-blue-600 text-white py-3 rounded-lg hover:bg-blue-700 transition"
                >
                  {btnText}
                </button>
              </form>

              {/* Register Link */}
              {/* <p className="text-center text-black mt-8">
                Don't have an account?{" "}
                <a href="#" className="text-blue-500">
                  Register here
                </a>
              </p> */}

              {/* Admissions */}
            </div>
          </div>
        </div>
        {/* <Footer/> */}
      </div>
      <div className="p-2 mt-auto bg-blue-600 text-lg">
        <Marque className="text-white" direction="right">
          {`Welcome to ${InstitutionName}. I hope you have a wonderful experience and stay here!`}
        </Marque>
      </div>
    </div>
  );
};

export default PortalSignup;
